
<template>
  <!--小区管理-->
  <div>
    <x-tabula
      ref="table"
      :apiOrigin="apiOrigin"
      :searchList="searchList"
      rowKey="communityId"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'community',
  data () {
    return {
      apiOrigin: 'JAVA',
      searchList: [
        { label: '', props: ['keywords'], placeholder: '小区名称', options: [], inputType: 'input' },
        {
          label: '',
          props: ['areas'],
          placeholder: '选择省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(1, 'searchList', '1,2,3', e);
          }
        },
        { label: '', props: ['propertyId'], placeholder: '选择物业', options: [], inputType: 'select' },
        { label: '', props: ['standardAddress'], placeholder: '标准地址查询', options: [], inputType: 'input' },
        { label: '', props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'add', permi: ['community:info:add'] },
        { text: '删除', icon: 'close', key: 'delete', disabled: true, permi: ['community:info:remove'] }
      ],
      rowOptList: [
        { text: '小区配置', handle: (record) => this.authManage(record.communityId), permi: ['community:config:query'] },
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:info:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record, record.community_name), permi: ['community:info:remove'] }
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '小区名称', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '所属物业', dataIndex: 'propertyFullName', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      searchParams: {
        keywords: undefined,
        areas: undefined,
        propertyId: undefined,
        standardAddress: undefined,
        createDate: undefined
      },
      listApi: {
        url: 'community/list',
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addCommunity',
        addTitle: '新增小区',
        editTitle: '修改小区'
      },
      deleteParam: {
        url: 'community/',
        // param: {pk_key: 'community_id', pk_val: ''},
        param: {},
        title: '小区',
        key: 'communityName'
      }
    };
  },
  computed: {
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(1, 'searchList', '1,2,3');
      this.propertySelect(2);
    },
    /* 小区配置 */
    authManage (id) {
      this.$router.push({
        name: 'communityConfig',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
